// Shared helpers + primitives for all Report tabs.
// Split out of the (formerly 3k-line) Reports.jsx so each report can live
// in its own file under /components/reports/.
import { toast } from "sonner";

export const ORANGE = "#FF5A00";

export function downloadCSV(filename, header, rows) {
  if (!rows.length) { toast.error("No data to export"); return; }
  const escape = (v) => {
    if (v === null || v === undefined) return "";
    const s = String(v);
    return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  const csv = [header.join(",")].concat(rows.map((r) => r.map(escape).join(","))).join("\n");
  const blob = new Blob([csv], { type: "text/csv" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${filename}_${new Date().toISOString().slice(0, 10)}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}

export function inr(n) {
  return (n || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 });
}

export function Kpi({ label, value, suffix, tone }) {
  const toneCls = tone === "warn" ? "text-amber-700"
    : tone === "bad" ? "text-rose-700"
    : tone === "good" ? "text-emerald-700"
    : "text-neutral-900";
  return (
    <div className="border border-neutral-200 bg-white p-4">
      <div className="label-caps text-neutral-500">{label}</div>
      <div className={`mt-1 font-mono-num text-2xl font-bold ${toneCls}`}>
        {value}{suffix ? <span className="text-base ml-0.5">{suffix}</span> : null}
      </div>
    </div>
  );
}

export function EmptyRow({ cols, msg = "No data." }) {
  return <tr><td colSpan={cols} className="px-4 py-10 text-center text-neutral-400">{msg}</td></tr>;
}

// Used by InquiryConversionReport
export function KpiCard({ label, value, hint, accent, testId }) {
  return (
    <div className="border border-neutral-200 bg-white p-4" data-testid={testId}>
      <div className="label-caps text-neutral-500">{label}</div>
      <div className="mt-1 font-mono-num text-2xl font-bold" style={accent ? { color: accent } : {}}>
        {value ?? 0}
      </div>
      {hint && <div className="text-xs text-neutral-400 mt-0.5">{hint}</div>}
    </div>
  );
}

export function FunnelRow({ label, num, den, pct, orders, orderLabel }) {
  const width = Math.min(100, Math.max(0, pct || 0));
  return (
    <div className="border border-neutral-200 bg-white p-4">
      <div className="flex items-baseline justify-between">
        <div className="text-sm font-medium">{label}</div>
        <div className="font-mono-num text-lg font-semibold">{pct}%</div>
      </div>
      <div className="mt-2 h-2 bg-neutral-100 overflow-hidden rounded-sm">
        <div className="h-full bg-[#FF5A00]" style={{ width: `${width}%` }} />
      </div>
      <div className="flex items-center justify-between mt-2 text-xs text-neutral-500">
        <span>
          <span className="font-mono-num font-bold text-neutral-900">{num}</span> of {den} converted
        </span>
        <span>
          <span className="font-mono-num font-bold text-neutral-900">{orders}</span> {orderLabel}
        </span>
      </div>
    </div>
  );
}
